import { INDIVIDUAL } from '@/modules/booking_resources/common/capacity';

export default {
  computed: {
    isIndividual() {
      return this.resource.capacity_type === INDIVIDUAL;
    }
  }
};
